"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var _default = {
  "setOwnerCutPerMillion(uint256)": "Set fees to `@formatPct($1, 1000000)`%",
  "transferMarketplaceOwnership(address)": "Transfer ownership of the marketplace to `$1`",
  "transferOwnership(address)": "Transfer ownership of the contract to `$1`",
  "pause()": "Pause contract",
  "unpause()": "Unpause Contract`"
};
exports.default = _default;